import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@core/components/toasts/toasts.service';
import { ErrorModel } from './models/error.model';

@Injectable()
export class HandleErrorService {
  errors: ErrorModel[];
  httpErrors: any;

  constructor(private toasterService: ToastService) {}

  public handleError(err: HttpErrorResponse) {
    const handleMessage = (error) => {
      const messages = [
        ...new Set(
          []
            .concat(
              error?.error?.errors?.messages,
              error?.error?.errors?.Messages,
              Object.values(error?.error?.errors || {}).flat(),
              [error?.error?.Message]
            )
            .filter((x) => typeof x === "string" && x)
        ),
      ];
      switch (error.status) {
        case 0:
          return [
            ErrorModel.create({
              status: 0,
              message: 'Ocorreu um erro ao tentar se conectar com o servidor',
            }),
          ];
        case 400:
          return messages.length > 0
            ? messages.map((message) =>
                ErrorModel.create({ status: 400, message })
              )
            : [
                ErrorModel.create({
                  status: 400,
                  message: 'Requisição inválida',
                }),
              ];
        case 401:
          return [
            ErrorModel.create({
              status: 401,
              message: 'Faça login para continuar',
            }),
          ];
        case 500:
          return messages.length > 0
            ? messages.map((message) =>
                ErrorModel.create({ status: 500, message })
              )
            : [
                ErrorModel.create({
                  status: 500,
                  message: 'Falha na comunicação',
                }),
              ];
        default:
          return messages.length > 0
            ? messages.map((message) =>
                ErrorModel.create({ status: error.status, message })
              )
            : [
                ErrorModel.create({
                  status: error.status,
                  message: 'Erro desconhecido',
                }),
              ];
      }
    };

    if (err.error && ['operationSuccess', 'isSuccessStatusCode'].some(key =>Object.keys(err.error).includes(key))) {
      if (err.error.status === 400) {
        this.toasterService.showWarning(err.error.message || err.error.Message);
      } else {
        this.toasterService.showError(err.error.message || err.error.Message);
      }
      return;
    } else if (err.error instanceof ErrorEvent) {
      // Erro no frontend ou erro de rede
      this.errors = [
        ErrorModel.create({
          status: err.status,
          message: `Ocorreu um erro: ${err.message}`,
        }),
      ];
    } else {
      this.errors = handleMessage(err);
    }

    (this.errors || []).forEach((errorItem) => {
      if (errorItem.status === 400) {
        this.toasterService.showWarning(errorItem.message);
      } else {
        this.toasterService.showError(errorItem.message);
      }
    });
  }

  public handleNotification(notificationBase64: string) {
    const decoded = decodeURIComponent(escape(atob(notificationBase64)));
  
    this.toasterService.showInfo(decoded, 'top-right');
  }  
}
